/**
 * <Title> — heading encapsulation of <Text>.
 *
 * Pins the parent-design title preset: `text-2xl`, bold, brand primary (marine).
 * Any prop can still be overridden by
 * the caller (e.g. `<Title color="text-strong">`), but PREFER using it as-is so
 * headings stay consistent across screens.
 */
import React from "react"

import { Text, type TextProps } from "../Text"

export type TitleProps = TextProps

export function Title({ size = "text-2xl", ...props }: TitleProps) {
    return <Text size={size} weight="bold" color="primary" {...props} />
}
